<template>
  <div class="content" ref="content">
    <div class="infos-list">
      <!-- 1 -->
      <div class="infos-item infos-item-1">
        <div class="infos-item-left">
          <img class="info-item-pic info-item-pic-1" src="../assets/join-infos-1.png"/>
        </div>
        <div class="infos-item-right">
          <div class="run-icon-wrap">
            <img :class="['infos-item-icon', 'animate__animated', !iscn &&'infos-item-icon-en']" src="../assets/join-infos-2.png"/>
          </div>
          <img v-if="iscn" class="infos-item-title infos-item-title-pic" src="../assets/join-infos-7.png"/>
          <img v-else class="infos-item-title infos-item-title-pic infos-item-title-pic-en" src="../assets/join-infos-7-en.png"/>
          <div v-if="iscn" class="infos-item-subtitle">在绿色大运的理念下，转转携手成都第31届世界大学生夏季运动会，为全球运动员提供免费的二手手机借还服务。这是国际综合赛事首次引入二手循环服务。一万台“官方验”二手手机亮相国际舞台，既解决了代表团成员的实际通讯问题，又践行了低碳环保。</div>
          <div v-else class="infos-item-subtitle infos-item-subtitle-en">ZhuanZhuan has partnered with the 31st Summer Universiade in Chengdu to provide free second-hand phone lending and return services for athletes, marking the first time such services have been offered at an international multi-sport event. Ten thousand "officially verified" second-hand phones were showcased, addressing communication needs and promoting low-carbon practices.</div>
        </div>
      </div>
      <!-- 2 -->
      <div class="infos-item infos-item-2">
        <div :class="['infos-item-left', !iscn&&'infos-item-left-en']">
          <img class="infos-item-icon" src="../assets/join-infos-3.png"/>
          <div v-if="iscn" class="infos-item-title">旧物炼金，变废为宝</div>
          <div v-else class="infos-item-title infos-item-title-en">Trash to treasure: Gold recovery from old mobile phones</div>
          <div v-if="iscn" class="infos-item-subtitle">你家里是否也有几部闲置的旧手机？转转通过与专业有资质的拆解企业的合作，把数万台废旧手机从垃圾堆里解救出来，提炼成真金白银！我们还委托了B站UP主，用其中一部分废旧手机提炼的黄金，做成了一张纯金的金榜，为高考的学子们加油打气，同时也传播我们的循环理念。</div>
          <div v-else class="infos-item-subtitle infos-item-subtitle-en">Got old phones gathering dust? ZhuanZhuan, in partnership with certified recyclers, has rescued tens of thousands of discarded phones and turned them into valuable resources. We also collaborated with a Bilibili creator to transform gold from these phones into a plaque, inspiring Gaokao students and promoting our circular economy concept.</div>
        </div>
        <div class="infos-item-right">
          <img class="info-item-pic info-item-pic-2" src="../assets/join-infos-4.png"/>
          <img @click="toggleVideo('0')" class="info-item-play" src="../assets/join-infos-9.png"/>
        </div>
      </div>
      <!-- 3 -->
      <div class="infos-item infos-item-3">
        <div class="infos-item-left">
          <img class="info-item-pic info-item-pic-3" src="../assets/join-infos-5.png"/>
          <img @click="toggleVideo('1')" class="info-item-play" src="../assets/join-infos-9.png"/>
        </div>
        <div class="infos-item-right">
          <img class="infos-item-icon" src="../assets/join-infos-6.png"/>
          <div v-if="iscn" class="infos-item-title">穿越极致冰川·见证气候变化</div>
          <div v-else class="infos-item-title infos-item-title-en">Glaciers expetidition: Witnessing climate change</div>
          <div v-if="iscn" class="infos-item-subtitle">2024年，转转团队联合“中国国家地理”和B站UP主“影视飓风”，深入藏东南冰川，亲自见证和记录了冰川的消融过程。我们想向大家证明一件事：气候真的在变暖！我们也更加坚信，二手是一件很低碳环保、拯救世界的事。</div>
          <div v-else class="infos-item-subtitle infos-item-subtitle-en">In 2024, ZhuanZhuan, in partnership with China National Geography and a Bilibili creator, traveled to Southeastern Tibet to document glacier melt, highlighting climate change. We aimed to show that second-hand products are a sustainable way to help protect the planet.</div>
        </div>
      </div>
    </div>
    <!-- 炼金视频 -->
    <div class="video-wrap">
      <z-icon @click="toggleVideo('0')" class="close-icon" class-prefix="zziconfont-6" name="close" />
      <video id="myVideo1" class="fullscreen" controls>
        <source src="https://sf4930.zhuanstatic.com/2fx45XChBjt/b40a01f4-f351-11ef-9c7d-ee7b0ea89ae9.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <!-- 冰川视频 -->
    <div class="video-wrap">
      <z-icon @click="toggleVideo('1')" class="close-icon" class-prefix="zziconfont-6" name="close" />
      <video id="myVideo2" class="fullscreen" controls>
        <source src="https://sf4930.zhuanstatic.com/2fx45XChBjt/335350c1-69e9-11f0-bf88-369e1ec0cd17.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'
import { Icon } from '@zz-common/zz-ui';
Vue.use(Icon);

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()
    this.addListenFullScreen()

    new Rellax('.infos-item-1', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.infos-item-2', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.infos-item-3', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            //
            if (entry.target.classList.contains('info-item-pic-1') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.info-item-pic')[0]?.classList?.add('zoom-in')
              }, 70)
              setTimeout(() => {
                document.querySelectorAll('.infos-item-icon')[0]?.classList?.add('slide-in-left')
              }, 300)
              setTimeout(() => {
                document.querySelectorAll('.infos-item-title-pic')[0]?.classList?.add('fade-in')
                document.querySelectorAll('.infos-item-subtitle')[0]?.classList?.add('fade-in')
              }, 600)
            }
            //
            if (entry.target.classList.contains('info-item-pic-2') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.info-item-pic')[1]?.classList?.add('zoom-in')
              }, 70)
              setTimeout(() => {
                document.querySelectorAll('.infos-item-icon')[1]?.classList?.add('fade-in')
                document.querySelectorAll('.infos-item-title')[1]?.classList?.add('fade-in')
                document.querySelectorAll('.infos-item-subtitle')[1]?.classList?.add('fade-in')
              }, 500)
            }
            //
            if (entry.target.classList.contains('info-item-pic-3') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.info-item-pic')[2]?.classList?.add('zoom-in')
              }, 70)
              setTimeout(() => {
                document.querySelectorAll('.infos-item-icon')[2]?.classList?.add('fade-in')
                document.querySelectorAll('.infos-item-title')[2]?.classList?.add('fade-in')
                document.querySelectorAll('.infos-item-subtitle')[2]?.classList?.add('fade-in')
              }, 500)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.info-item-pic-1') as Element)
      observer.observe(document.querySelector('.info-item-pic-2') as Element)
      observer.observe(document.querySelector('.info-item-pic-3') as Element)
    },
    addListenFullScreen() {
      document.addEventListener('keydown', (event) => {
        // 判断按下的键是否是Esc键
        if (event.key === 'Escape') {
        // 如果是Esc键，执行相应的逻辑
          document.querySelectorAll('.video-wrap').forEach((item) => {
            item.classList.remove('show-video')
          })
        }
      });
      // 监听全屏状态变化
      // document.addEventListener('fullscreenchange', function() {
      //   if (document.fullscreenElement === null) {
      //     // 退出全屏后需要执行的代码
      //     document.getElementById('myVideo1')?.classList?.remove('fullscreen')
      //     document.getElementById('myVideo2')?.classList?.remove('fullscreen')
      //   } else {
      //     // 进入全屏后需要执行的代码
      //   }
      // });
    },
    toggleVideo(type) {
      const video: any = document.querySelectorAll('.video-wrap')[Number(type)];
      if (video?.classList?.contains('show-video')) {
        video.classList.remove('show-video');
        // document.exitFullscreen(); // 退出全屏模式（如果需要）
      } else {
        video?.classList?.add('show-video');
        // 全屏操作
        // if (video?.requestFullscreen) {
        //   video.requestFullscreen?.();
        // } else if (video?.mozRequestFullScreen) { /* Firefox */
        //   video?.mozRequestFullScreen?.();
        // } else if (video?.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        //   video?.webkitRequestFullscreen?.();
        // } else if (video?.msRequestFullscreen) { /* IE/Edge */
        //   video?.msRequestFullscreen?.();
        // }
      }
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes slideInLeft1 {
  from {
    transform: translateX(-2000px);
  }

  to {
    transform: translateX(0);
  }
}

.fade-in {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}
.slide-in-left {
  animation: slideInLeft1 1s 0s forwards;
}

.earth-banner-up {
  animation: slideUp 0.8s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 2393px;
  margin: 0 auto;
  background: #fff;
}
.infos-list {
  width: 1567px;
  margin: 0 auto;
  // height: 2073px;
  // position: absolute;
  // left: 50%;
  // margin-left: -783px;
  .infos-item {
    display: flex;
    justify-items: center;
    justify-content: flex-start;
    text-align: left;
    &:nth-of-type(1){
      height: 587px;
      .info-item-pic {
        height: 472px;
      }
      .run-icon-wrap {
        position: relative;
        // width: 2000px;
        // margin-left: -1000px;
        height: 123px;
      }
      .infos-item-icon {
        width: 136px;
        height: 123px;
        opacity: 1;
        position: absolute;
        transform: translateX(-2000px);
        // left: 500px;
        &.infos-item-icon-en {
          width: 116px;
          height: 105px;
        }
      }
      .infos-item-left {
        flex: 0 0 50%;
      }
      .infos-item-right {
        width: 687px;
        flex: 0 0 687px;
        margin-left: 100px;
      }
    }
    &:nth-of-type(2){
      height: 566px;
      padding-top:220px;
      .infos-item-icon {
        width: 123px;
        height: 110px;
      }
      .infos-item-left {
        width: 687px;
        flex: 0 0 687px;
        margin-right: 50px;
        margin-left: 50px;
        &.infos-item-left-en {
          margin-right: 100px;
          margin-left: 0px;
        }
      }
      .infos-item-right {
        flex: 0 0 50%;
      }
    }
    &:nth-of-type(3){
      height: 480px;
      padding-top:220px;
      .infos-item-icon {
        width: 209px;
        height: 90px;
      }
      .infos-item-left {
        flex: 0 0 50%;
      }
      .infos-item-right {
        width: 687px;
        flex: 0 0 687px;
        margin-left: 100px;
      }
    }
    .infos-item-left {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    .infos-item-right {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
  }
  .info-item-pic {
    width: 780px;
    height: 480px;
    position: absolute;
    top: 50%;
    margin-top: -240px;
    // transform: translateY(-50%);
    opacity: 0;
    &.info-item-pic-2 {
      cursor: pointer;
    }
    &.info-item-pic-3 {
      cursor: pointer;
    }
  }
  .info-item-play {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -42px 0 0 -44px;
    // transform: translate(-50%, -50%);
    width: 88px;
    height: 84px;
    cursor: pointer;
  }
  .infos-item-icon {
    opacity: 0;
  }
  .infos-item-title {
    font-family: alibaba;
    font-weight: 1000;
    font-size: 48px;
    color: #111111;
    line-height: 58px;
    padding: 40px 0 26px;
    opacity: 0;
    &.infos-item-title-en {
      width: 687px;
    }
  }
  .infos-item-title-pic {
    width: 428px;
    height: 120px;
    padding: 40px 0 24px;
    display: block;
    opacity: 0;
  }
  .infos-item-title-pic-en {
    width: 635px;
    height: 166px;
    padding: 40px 0 24px;
    display: block;
  }
  .infos-item-subtitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #111111;
    line-height: 36px;
    width: 640px;
    opacity: 0;
    word-break: break-word;

    &.infos-item-subtitle-en {
      width: 687px;
    }
  }
}

// .video-bg {
//   display: none;
//   background-color: #000;
//   &.fullscreen {
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     z-index: 1000; /* 或者其他高值，确保它在其他内容之上 */
//     display: block;
//     background-color: #000;
//   }
//   // .video-iframe {
//   //   width: 100%;
//   //   height: 100%;
//   // }
// }
.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    // width: 100%;
    width: 100%;
    height: 100%;
    z-index: 1000; /* 或者其他高值，确保它在其他内容之上 */
    display: block;
    background-color: #000;
    object-fit: contain;
  }
.video-wrap {
  position: relative;
  display: none;
  .close-icon {
    position: fixed;
    width: 38px;
    height: 38px;
    background: #fff;
    right: 40px;
    top: 40px;
    border-radius: 8px;
    z-index: 9999;
    font-size: 38px;
    cursor: pointer;
  }
  &.show-video {
    display: block;
  }
}

// #myVideo1 {
//   display: none;
// }
// #myVideo2 {
//   display: none;
// }
</style>
